// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__p3Y9f","title":"Images90_title__1vqOj","images":"Images90_images__38FGk"};